// removed by extract-text-webpack-plugin
module.exports = {"header":"pages-MyAccount-share-AccountHeader-header","title":"pages-MyAccount-share-AccountHeader-title","titleInfo":"pages-MyAccount-share-AccountHeader-titleInfo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/MyAccount/share/AccountHeader/index.css
// module id = 1800
// module chunks = 0